import { lazy } from "react";

const ManagerDashboard = lazy(() => import("./ManagerDashboard"));


export { ManagerDashboard };